import type { Blocks } from '@w/content-blocks/src/block'
import { pageDocument } from '../doc-blocks'
import { pastedComments } from './clipboard'
import { spliceBlocks } from './ops'
import type { CoreState } from './state'
import { pointAt, rows, type Row } from './tree-read'
import { unsavedCopy } from './unsaved-copy'

/**
 * Copies of `blocks` for a duplicate: fresh identities, each question remapped once across them (unsavedCopy), and
 * comment refs as plain text, because a page names each thread once and the source keeps its ref (the paste rule,
 * clipboard.ts pastedComments).
 */
export function duplicates(state: CoreState, blocks: Blocks): Blocks {
  const qids = new Map<string, string>()
  return pastedComments(blocks.map((block) => unsavedCopy(block, qids)), pageDocument(state.doc).content)
}

/** The caret block (the owning list item for its first row), copied after itself with fresh identities. */
export function duplicateCaretBlock(state: CoreState, row: Row, offset: number): void {
  const owner = row.parents.at(-1)
  const list = row.parents.at(-2)
  const target = owner?.type === 'li' && owner.children[0] === row.block ? owner : row.block
  const siblings = target === owner && list ? list.children : row.siblings
  const [copy] = duplicates(state, [target])
  spliceBlocks(state, siblings, siblings.indexOf(target) + 1, 0, copy)
  const point = pointAt(rows([copy])[0], offset)
  state.selection = { anchor: point, focus: point }
}
